import { render, staticRenderFns } from "./EquipmentMaintenance.vue?vue&type=template&id=824292c6&scoped=true&"
import script from "./EquipmentMaintenance.vue?vue&type=script&lang=ts&"
export * from "./EquipmentMaintenance.vue?vue&type=script&lang=ts&"
import style0 from "./EquipmentMaintenance.vue?vue&type=style&index=0&id=824292c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824292c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VTab,VTabs})
